import * as React from 'react'
import { SignUp as AwsSignUp, AuthPieceProps } from 'aws-amplify-react'
import { Form, FormRenderProps, AnyObject } from 'react-final-form'
import { SignUp } from './SignUp'
import bind from 'bind-decorator'
import { SignUpFormSubmission } from './types'
import Auth from '@aws-amplify/auth'
import { SignUpParams } from '@aws-amplify/auth/lib/types'
import { phoneToAws } from '../../components'
import { ApplicationState } from '../../reducers'
import { bool } from 'aws-sdk/clients/signer'
import { connect } from 'react-redux'
import { dataLayerPushEvent, dataLayerPushPageType } from '../../services/gtm'
import { history } from '../../history'

type OwnProps = {
    setPassword: (password: string) => void
}

type ComponentProps = OwnProps & {
    isJoin: bool
}

type Props = AuthPieceProps & ComponentProps

type State = {
    error?: Error
}

class AwsSignUpWithData extends AwsSignUp<Props, State> {
    readonly state: State = {}

    componentDidUpdate() {
        if (this.props.isJoin) {
            this.changeState('signUp')
            dataLayerPushPageType('Signup')
        } else {
            dataLayerPushPageType('Login')
        }
    }

    @bind
    async onSubmit(values: AnyObject) {
        const {
            email,
            password,
            emails,
            firstName,
            gender,
            lastName,
            mobile,
            addressone,
            addresstwo,
            suburb,
            state,
            postcode,
        } = values as SignUpFormSubmission

        this.props.setPassword(password)

        const address = {
            street_address: addressone,
            address_2: `${addresstwo ? addresstwo : ''}`,
            locality: suburb,
            region: state,
            postal_code: postcode,
            country: 'Australia',
        }

        const signupInfo: SignUpParams = {
            password,
            username: email,
            attributes: {
                email,
                gender,
                address: JSON.stringify(address),
                'custom:postcode': postcode,
                'custom:marketing_opt_in': emails ? 'true' : 'false',
                given_name: firstName,
                family_name: lastName,
                phone_number: phoneToAws(mobile),
            },
        }

        try {
            dataLayerPushEvent('accountRequest', '', '')
            this.setState({ error: undefined })
            const result = await Auth.signUp(signupInfo)
            history.replace('/account')
            this.changeState('confirmSignUp', result.user.getUsername())
            window.scrollTo(0, 0)
        } catch (error) {
            this.setState({ error })
        }
    }

    @bind
    renderForm({ handleSubmit }: FormRenderProps) {
        const { error } = this.state

        return (
            <SignUp
                handleSubmit={handleSubmit}
                error={error}
            />
        )
    }

    showComponent() {
        return (
            <Form
                onSubmit={this.onSubmit}
                render={this.renderForm}
            />
        )
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps): ComponentProps => {
    const params = new URLSearchParams(state.router.location.search)

    return {
        ...ownProps,
        isJoin: params.get('join') !== null,
    }
}

const SignUpWithData = connect(mapStateToProps)(AwsSignUpWithData)

export { SignUpWithData }
